import { Extension } from "@37signals/lexxy"
import { defineExtension } from "lexical"

export class NoHighlightExtension extends Extension {
  get enabled() {
    return this.editorElement?.dataset.noHighlight === "true"
  }

  initializeToolbar(toolbar) {
    toolbar.querySelector("lexxy-highlight-dropdown")?.remove()
  }

  get lexicalExtension() {
    return defineExtension({
      name: "mstone/no_highlight",
      register(editor) {
        // Strip color/background-color styles applied via highlight on paste or input
        return editor.registerNodeTransform(editor._nodes.get("text")?.klass, (textNode) => {
          const style = textNode.getStyle()
          if (!style) return

          const cleaned = style
            .split(";")
            .map(s => s.trim())
            .filter(s => s && !s.startsWith("color") && !s.startsWith("background-color"))
            .join("; ")

          if (cleaned !== style) {
            textNode.setStyle(cleaned || "")
          }
        })
      }
    })
  }
}
